// import React from 'react';
// import styles from '../../assets/scss/Dashboard.module.scss';
// import {
//     FiBox,
//     FiUsers,
//     FiClock,
// } from 'react-icons/fi';
// import { Doughnut } from 'react-chartjs-2';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";
// import {
//     Chart as ChartJS,
//     ArcElement,
//     Tooltip,
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     PointElement,
//     LineElement,
// } from 'chart.js';
// import { useNavigate } from 'react-router-dom';
// import { useGetDashboardQuery } from '../../slices/admin/admin';
// import dummyProfile from "../../assets/images/Profile.png";
// import { BaseURL } from '../../lib/api';


// ChartJS.register(
//     ArcElement,
//     Tooltip,
//     Legend,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     PointElement,
//     LineElement
// );

// const RetailOwnerCustomer = () => {
//     const navigate = useNavigate();
//     const { data, isLoading } = useGetDashboardQuery();


//     // console.log("Dashboard Data:", data);


//     const totalOrders = data?.data?.totalOrders || 0;
//     const inProgressOrdersCount = data?.data?.inProgressOrdersCount || 0;
//     const totalPayableCredit = data?.data?.totalPayableCredit || 0;
//     const totalPendingBills = data?.data?.totalPendingBills || 0;

//     const orderData = {
//         labels: ['Total Orders', 'In Progress', 'Pending Bills', 'Payable Credit'],
//         datasets: [
//             {
//                 data: [totalOrders, inProgressOrdersCount, totalPendingBills, totalPayableCredit],
//                 backgroundColor: ['#08a045', '#87e892', '#dbf3c9', '#c3f550'],
//                 borderWidth: 0,
//                 circumference: 360,
//                 rotation: -90,
//                 cutout: '60%',
//             },
//         ],
//     };

//     const options = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: {
//                 display: true,
//                 position: 'left',
//             },
//         },
//     };

//     return (
//         <div className={styles.dashboard}>
//             {/* Row 1 */}
//             <div className={styles.grid}>
//                 {/* Order Overview */}
//                 <div className={styles.card}>
//                     <div className={styles.header}>
//                         <h4 className={styles.heading}>Order Overview</h4>
//                         <span onClick={() => navigate('/dashboard/Ordertable')}>View all</span>
//                     </div>
//                     <div className={styles.orderChartWrapper}>
//                         <div className={styles.chartContainer}>
//                             {isLoading ? <p>Loading...</p> : <Doughnut data={orderData} options={options} />}
//                         </div>
//                     </div>
//                 </div>

//                 <div className={styles.card}>
//                     <div className={styles.header}>
//                         <h4 className={styles.heading}>Price Range</h4>
//                         {/* <span onClick={() => navigate("/dashboard/Notifications")}>
//                             View all
//                         </span> */}
//                     </div>
//                     <div className={styles.notificationsfarmer}>
//                         {data?.data?.matchedInventories?.map((inv, idx) => (
//                             <div key={idx} className={styles.notificationsfarmerinside}>
//                                 <div>
//                                     <p>
//                                         <strong>{inv.productName}</strong> – From: ₹
//                                         {inv.buyingPrice}, To: ₹{inv.sellingPrice}
//                                     </p>

//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* Notifications (static for now) */}
//                 <div className={styles.card}>

//                     {/* <div className={styles.notifications}>
//                         {data?.data?.notifications?.slice(0, 3).map((note) => (
//                             <div key={note._id} className={styles.notification}>
//                                 <img
//                                     src={
//                                         note.createdBy?.profile
//                                             ? `${BaseURL}/${note.createdBy?.profile}`
//                                             : dummyProfile
//                                     }
//                                     alt={note.createdBy?.name || "User"}
//                                 />
//                                 <div>
//                                     <p>{note.message}</p>
//                                     <span>
//                                         <FiClock /> {new Date(note.createdAt).toLocaleDateString()}
//                                     </span>
//                                 </div>
//                             </div>
//                         ))}
//                     </div> */}
//                     <div className={styles.cards}>
//                         <div className={styles.header}>
//                             <h4 className={styles.heading}>Banner</h4>
//                         </div>
//                         <div className={styles.bannerSliderWrapper}>
//                             {data?.data?.bannerImages?.length > 0 ? (
//                                 <Slider
//                                     dots={true}
//                                     infinite={true}
//                                     speed={500}
//                                     slidesToShow={1}
//                                     slidesToScroll={1}
//                                     autoplay={true}
//                                     autoplaySpeed={3000}
//                                     arrows={false}
//                                 >
//                                     {data.data.bannerImages.map((img, idx) => (
//                                         <div key={idx} className={styles.bannerSlide}>
//                                             <img
//                                                 src={`${BaseURL}/${img}`}
//                                                 alt={`banner-${idx}`}
//                                                 className={styles.bannerimg}
//                                             />
//                                         </div>
//                                     ))}
//                                 </Slider>
//                             ) : (
//                                 <p>No banner images available</p>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Row 2 */}
//             <div className={styles.grids}>
//                 <div className={styles.card}>
//                     <div className={styles.header}>
//                         <h4 className={styles.heading}>Notifications</h4>
//                         <span onClick={() => navigate('/dashboard/Notifications')}>View all</span>
//                     </div>

//                     <div className={styles.notificationsfarmerbanner}>
//                         {data?.data?.notifications?.slice(0, 10).map((note) => (
//                             <div
//                                 key={note._id}
//                                 className={`${styles.notification} ${note.isRead === false ? styles.unreadNotification : ""
//                                     }`}
//                             >
//                                 <img
//                                     src={
//                                         note.createdBy?.profile
//                                             ? `${BaseURL}/${note.createdBy?.profile}`
//                                             : dummyProfile
//                                     }
//                                     alt={note.createdBy?.firstName || "User"}
//                                 />
//                                 <div>
//                                     <p>{note.message}</p>
//                                     <span
//                                         className={note.isRead === false ? styles.redText : ""}
//                                     >
//                                         <FiClock
//                                             className={note.isRead === false ? styles.redIcon : ""}
//                                         />{" "}
//                                         {new Date(note.createdAt).toLocaleDateString("en-GB")}
//                                     </span>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>

//                 </div>



//                 {/* ✅ Extra Static Box Example */}
//                 <div className={styles.card}>
//                     <div className={styles.header}>
//                         <h4 className={styles.heading}>Bill Overview</h4>
//                         <span onClick={() => navigate("/dashboard/billing")} >View all</span>
//                     </div>
//                     <div className={styles.overviewGrids}>
//                         <div className={`${styles.box} ${styles.orange}`}>
//                             <FiBox className={styles.icon} />
//                             <h3>{data?.data?.totalPayableCredit || 0}</h3>
//                             <p>Payable Credit</p>
//                         </div>
//                         <div className={`${styles.box} ${styles.purple}`}>
//                             <FiUsers className={styles.icon} />
//                             <h3>{data?.data?.totalPendingBills || 0}</h3>
//                             <p>Pending Bills</p>
//                         </div>

//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default RetailOwnerCustomer;


import React from 'react';
import styles from '../../assets/scss/Dashboard.module.scss';
import {
    FiBox,
    FiUsers,
    FiClock,
} from 'react-icons/fi';
import { Doughnut } from 'react-chartjs-2';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
} from 'chart.js';
import { useNavigate } from 'react-router-dom';
import { useGetDashboardQuery } from '../../slices/admin/admin';
import dummyProfile from "../../assets/images/Profile.png";
import { BaseURL } from '../../lib/api';

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement
);

const RetailOwnerCustomer = () => {
    const navigate = useNavigate();
    const { data, isLoading } = useGetDashboardQuery();

    // ✅ Helper function for safe image URLs
    const getImageUrl = (path) => {
        if (!path || typeof path !== 'string') return dummyProfile;
        if (path.startsWith('http://') || path.startsWith('https://')) return path;
        return `${BaseURL}/${path.replace(/^\/+/, '')}`;
    };

    const totalOrders = data?.data?.totalOrders || 0;
    const inProgressOrdersCount = data?.data?.inProgressOrdersCount || 0;
    const totalPayableCredit = data?.data?.totalPayableCredit || 0;
    const totalPendingBills = data?.data?.totalPendingBills || 0;

    const orderData = {
        labels: ['Total Orders', 'In Progress', 'Pending Bills', 'Payable Credit'],
        datasets: [
            {
                data: [totalOrders, inProgressOrdersCount, totalPendingBills, totalPayableCredit],
                backgroundColor: ['#08a045', '#87e892', '#dbf3c9', '#c3f550'],
                borderWidth: 0,
                circumference: 360,
                rotation: -90,
                cutout: '60%',
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'left',
            },
        },
    };

    return (
        <div className={styles.dashboard}>
            {/* Row 1 */}
            <div className={styles.grid}>
                {/* Order Overview */}
                <div className={styles.card}>
                    <div className={styles.header}>
                        <h4 className={styles.heading}>Order Overview</h4>
                        <span onClick={() => navigate('/dashboard/Ordertable')}>View all</span>
                    </div>
                    <div className={styles.orderChartWrapper}>
                        <div className={styles.chartContainer}>
                            {isLoading ? <p>Loading...</p> : <Doughnut data={orderData} options={options} />}
                        </div>
                    </div>
                </div>

                {/* Price Range */}
                <div className={styles.card}>
                    <div className={styles.header}>
                        <h4 className={styles.heading}>Price Range</h4>
                    </div>
                    <div className={styles.notificationsfarmer}>
                        {data?.data?.matchedInventories?.map((inv, idx) => (
                            <div key={idx} className={styles.notificationsfarmerinside}>
                                <div>
                                    <p>
                                        <strong>{inv.productName}</strong> – From: ₹{inv.buyingPrice}, To: ₹{inv.sellingPrice}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Banner Section */}
                <div className={styles.bannerCard}>
                    <div className={styles.header}>
                        <h4 className={styles.heading}>Banner</h4>
                    </div>
                    <div className={styles.bannerSliderWrapper}>
                        {data?.data?.bannerImages?.length > 0 ? (
                            <Slider
                                dots={true}
                                infinite={true}
                                speed={800}
                                slidesToShow={1}
                                slidesToScroll={1}
                                autoplay={true}
                                autoplaySpeed={3500}
                                arrows={false}
                            >
                                {data.data.bannerImages.map((img, idx) => (
                                    <div key={idx} className={styles.bannerSlide}>
                                        <img
                                            src={getImageUrl(img)}
                                            alt={`banner-${idx}`}
                                            className={styles.bannerimg}
                                            onError={(e) => (e.target.src = dummyProfile)}
                                        />
                                    </div>
                                ))}
                            </Slider>
                        ) : (
                            <p>No banner images available</p>
                        )}
                    </div>
                </div>
            </div>

            {/* Row 2 */}
            <div className={styles.grids}>
                {/* Notifications */}
                <div className={styles.card}>
                    <div className={styles.header}>
                        <h4 className={styles.heading}>Notifications</h4>
                        <span onClick={() => navigate('/dashboard/Notifications')}>View all</span>
                    </div>

                    <div className={styles.notificationsfarmerbanner}>
                        {data?.data?.notifications?.length > 0 ? (
                            data.data.notifications.slice(0, 10).map((note) => (
                                <div
                                    key={note._id}
                                    className={`${styles.notification} ${note.isRead === false ? styles.unreadNotification : ""}`}
                                >
                                    <img
                                        src={getImageUrl(note.createdBy?.profile)}
                                        alt={note.createdBy?.firstName || "User"}
                                        onError={(e) => (e.target.src = dummyProfile)}
                                    />
                                    <div>
                                        <p>{note.message}</p>
                                        <span
                                            className={note.isRead === false ? styles.redText : ""}
                                        >
                                            <FiClock
                                                className={note.isRead === false ? styles.redIcon : ""}
                                            />{" "}
                                            {new Date(note.createdAt || Date.now()).toLocaleDateString("en-GB")}
                                        </span>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>No notifications available</p>
                        )}
                    </div>
                </div>

                {/* Bill Overview */}
                <div className={styles.card}>
                    <div className={styles.header}>
                        <h4 className={styles.heading}>Bill Overview</h4>
                        <span onClick={() => navigate("/dashboard/billing")}>View all</span>
                    </div>
                    <div className={styles.overviewGrids}>
                        <div className={`${styles.box} ${styles.orange}`}>
                            <FiBox className={styles.icon} />
                            <h3>{data?.data?.totalPayableCredit || 0}</h3>
                            <p>Payable Credit</p>
                        </div>
                        <div className={`${styles.box} ${styles.purple}`}>
                            <FiUsers className={styles.icon} />
                            <h3>{data?.data?.totalPendingBills || 0}</h3>
                            <p>Pending Bills</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RetailOwnerCustomer;
